import paymentCheckModule from "@/services/payment/payment_check/index";
import { PaymentWithSituationParams } from "@/services/offer/offer_handle";
import { throttle } from "@/utils/lodash";

export const payByAny = (payload: PaymentWithSituationParams) => {
  return inner(payload);
}
// 添加节流函数，避免连点
const inner: any = throttle((payload: PaymentWithSituationParams) => {
  paymentCheckModule.init(payload);
  paymentCheckModule.get().next();
}, 500)
